var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-middle"},[_c('h1',{staticStyle:{"font-size":"128px"}},[_vm._v("403")]),_c('h4',[_vm._v("ACCESS DENIED")])])}]

export { render, staticRenderFns }